import * as React from 'react'
import {Spin} from 'antd'
import './index.less'

interface LoadingProps {
  error?: any
  retry?: () => void
  timedOut?: boolean
  pastDelay?: boolean
}

const Loading = (props: LoadingProps) => {
  if (props.error) {
    return <div>Error! <button onClick={props.retry}>Retry</button></div>
  } else if (props.timedOut) {
    return <div>Taking a long time... <button onClick={props.retry}>Retry</button></div>
  } else if (props.pastDelay) {
    return <div className="loading-container">
      <Spin size="large"/>
    </div>
  } else {
    return null
  }
}
export default Loading
